import axios from 'axios'
import { toast } from 'react-toastify'
import { LOCAL_STORAGE_JWT_TOKEN } from 'domains/admin/constants'
import { normalizeOpsImageResponse } from 'utils/ops-image-url'

// Axios Defaults
axios.defaults.headers.common['Content-Type'] = 'application/json'

// API Base URL
axios.defaults.baseURL = process.env.REACT_APP_API_BASE

// ---------- Request Interceptor (attach token) ----------
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem(LOCAL_STORAGE_JWT_TOKEN)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// ---------- Response Interceptor (handle errors) ----------
const SESSION_TOAST_ID = 'session-expired'
const SESSION_EXPIRED_FALLBACK =
  'Session login sudah habis, silahkan login kembali menekan tombol F5 / atau refresh page'

axios.interceptors.response.use(
  (res) => normalizeOpsImageResponse(res),
  (error) => {
    const status = error?.response?.status

    if (status === 401) {
      const msg = error?.response?.data?.message || SESSION_EXPIRED_FALLBACK

      localStorage.removeItem(LOCAL_STORAGE_JWT_TOKEN)
      localStorage.setItem('logout', Date.now())

      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('bnk-auth-logout'))
      }

      // biar ga spam jika banyak request 401 barengan
      if (!toast.isActive(SESSION_TOAST_ID)) {
        toast.warn(msg, {
          toastId: SESSION_TOAST_ID,
          autoClose: false
        })
      }

      return Promise.reject(error)
    }

    toast.error('Oops... Something went wrong.')
    return Promise.reject(error)
  }
)
